export default "__VITE_ASSET__DgCqNEOB__"